import { useEffect as __mpUseEffect, useState as __mpUseState } from "react";
import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const __MP_CONTROLS = [{
  "id": "offboardingContext",
  "label": "Offboarding Context",
  "kind": "select",
  "group": "Options",
  "default": "standalone",
  "options": [{
    "value": "standalone",
    "label": "Standalone"
  }, {
    "value": "flow",
    "label": "Flow"
  }]
}, {
  "id": "flowOutcome",
  "label": "Flow Outcome",
  "kind": "select",
  "group": "Options",
  "default": "success",
  "options": [{
    "value": "success",
    "label": "Success"
  }, {
    "value": "followUp",
    "label": "Follow Up"
  }]
}];
function __mpIsValidControlValue(control, value) {
  if (control.kind === 'toggle') return typeof value === 'boolean';
  if (control.kind === 'number') {
    return typeof value === 'number' && Number.isFinite(value);
  }
  if (typeof value !== 'string' || value.length > 10000) return false;
  if (control.kind === 'select') {
    return control.options?.some(option => option.value === value) ?? false;
  }
  if (control.kind === 'color') {
    return /^#[0-9a-f]{6}$/i.test(value);
  }
  return true;
}
function __MPControlsRoot() {
  const [overrides, setOverrides] = __mpUseState({});
  __mpUseEffect(() => {
    const handleValues = event => {
      const nextValues = event.detail?.values;
      if (!nextValues || typeof nextValues !== 'object' || Array.isArray(nextValues)) {
        return;
      }
      const normalized = {};
      for (const control of __MP_CONTROLS) {
        const value = nextValues[control.id];
        if (__mpIsValidControlValue(control, value)) {
          normalized[control.id] = value;
        }
      }
      setOverrides(normalized);
    };
    const announceControls = () => {
      window.dispatchEvent(new CustomEvent('magicpatterns:controls-ready', {
        detail: {
          controls: __MP_CONTROLS
        }
      }));
    };
    window.addEventListener('magicpatterns:controls-values', handleValues);
    window.addEventListener('magicpatterns:controls-request', announceControls);
    announceControls();
    return () => {
      window.removeEventListener('magicpatterns:controls-values', handleValues);
      window.removeEventListener('magicpatterns:controls-request', announceControls);
    };
  }, []);
  return <App {...overrides} />;
}
render(<__MPControlsRoot />, document.getElementById('root'));